import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HttpServiceService {

  constructor(private http: HttpClient) {

  }

  post<T>(endPoint: string, postData: any, url?: any, needtoAdd?: any): Observable<T> {
    return this.http.post<T>(url ? needtoAdd ? url + endPoint : url : environment.url.BACKEND_URL + `${endPoint}`, postData);
  }

  postoptions(endPoint: string, body: any, options?: any) {
  return this.http.post(environment.url.BACKEND_URL + `${endPoint}`, body, options);
}
  postText(endPoint: string, postData: any, url?: any, needtoAdd?: any): Observable<string> {
    return this.http.post(url ? needtoAdd ? url + endPoint : url : environment.url.BACKEND_URL + `${endPoint}`, postData, { responseType: 'text' });
  }

  postData<T>(endPoint: string, postData: any, url?: any): Observable<T> {
    return this.http.post<T>(url ? url : environment.url.AWARE_URL + `${endPoint}`, postData);
  }

  get<T>(endPoint: string, url?: any, needtoAdd?: any): Observable<T> {
    return this.http.get<T>(url ? needtoAdd ? url + endPoint : url : environment.url.BACKEND_URL + `${endPoint}`,);
  }

  getUMData<T>(endPoint: string, url?: any, needtoAdd?: any): Observable<T> {
    return this.http.get<T>(url ? needtoAdd ? url + endPoint : url : `${environment.url.UM_URL}${endPoint}`,);
  }
  getAwareWithParams<T>(endPoint: string, params: any, url?: string): Observable<T> {
    const fullUrl = url ? url : `${environment.url.AWARE_URL}${endPoint}`;
    const httpParams = new HttpParams({ fromObject: params });

    return this.http.get<T>(fullUrl, { params: httpParams });
  }

  getLayer<T>(endPoint: string, url?: any): Observable<T> {
    return this.http.get<T>(url ? url : environment.url.GEOPORTAL_CACHE + `${endPoint}`,);
  }
  gethightedLayer<T>(endPoint: string, url?: any): Observable<T> {
    return this.http.get<T>(url ? url : environment.url.GEOPORTAL + `${endPoint}`,);
  }

  gethightedLayerBlob(endPoint: string, url?: any): Observable<Blob> {
    const fullUrl = url ? url : environment.url.GEOPORTAL + `${endPoint}`;
    return this.http.get(fullUrl, { responseType: 'blob' });
  }
  gethightedLayerBlob1(endPoint: string, url?: any): Observable<Blob> {
    const fullUrl = url ? url : environment.url.BACKEND_URL + `${endPoint}`;
    return this.http.get(fullUrl, { responseType: 'blob' });
  }
  getBlob(endPoint: string, params: any, customUrl?: string): Observable<Blob> {
    const fullUrl = customUrl ? customUrl : `${environment.url.BACKEND_URL}${endPoint}`;

    // Ensure params are URLSearchParams-compatible
    const httpParams = new HttpParams({ fromObject: params });

    return this.http.get(fullUrl, {
      params: httpParams,
      responseType: 'blob'
    });
  }

  postBlob(endPoint: string, postData: any, url?: any): Observable<Blob> {
    const fullUrl = url ? url : environment.url.BACKEND_URL + `${endPoint}`;
    return this.http.post(fullUrl, postData, { responseType: 'blob' });
  }

}
